import { makeAutoObservable, runInAction } from 'mobx'
import {
  PrinterListTypes,
  PrintersType,
} from '~/shared/api/services/users/types'
import { PrintersService } from '~/shared/api/services/printers'
import { handleAxiosError } from '~/shared/lib'

export class PrinterStore {
  isLoading = false

  printers: PrinterListTypes = {
    text: {
      '4': 4,
      '6': 6,
      '16': 16,
    },
    label: {
      '1': 1,
      '3': 3,
      '5': 5,
      '15': 15,
    },
    zpl: {
      '7': 7,
      '8': 8,
      '9': 9,
      '10': 10,
      '11': 11,
      '12': 12,
      '13': 13,
      '14': 14,
    },
  }

  printersUser: Record<
    string,
    { label: string | number; value: string | number }
  > = {}

  userPrinters: Record<
    string,
    { label: string | number; value: string | number }
  > = {}

  modifiedPrinterFields: string[] = []

  constructor() {
    makeAutoObservable(this)
  }

  markPrinterFieldAsChanged = (printerType: string) => {
    if (!this.modifiedPrinterFields.includes(printerType)) {
      this.modifiedPrinterFields = [...this.modifiedPrinterFields, printerType]
    }
  }

  clearModifiedPrinterFields = () => {
    this.modifiedPrinterFields = []
  }

  setIsLoading = (isLoading: boolean) => {
    this.isLoading = isLoading
  }

  getPrinters = async () => {
    try {
      this.setIsLoading(true)

      const { data } = await PrintersService.getPrintersList()

      runInAction(() => {
        this.printers = { ...this.printers, ...data }
      })
    } catch (error) {
      const errorMessage = handleAxiosError(error)
      throw new Error(errorMessage)
    } finally {
      this.setIsLoading(false)
    }
  }

  setPrintersUser = (data: PrintersType | null | undefined) => {
    const dataToProcess = data || [{ text: 1 }, { label: 16 }, { zpl: 10 }]

    this.printersUser = dataToProcess.reduce<
      Record<string, { label: string | number; value: string | number }>
    >((acc, cur) => {
      const [key, value] = Object.entries(cur).flat()
      acc[key] = { label: value, value }
      return acc
    }, {})
  }

  updatePrinterUser = (key: string, value: string | number) => {
    const newValues = { ...this.printersUser }
    newValues[key] = { label: value, value }
    this.printersUser = newValues
  }

  setPrintersProfile = (data: PrintersType | null | undefined) => {
    const dataToProcess = data || [{ text: 3 }, { label: 6 }, { zpl: 9 }]

    this.userPrinters = dataToProcess.reduce<
      Record<string, { label: string | number; value: string | number }>
    >((acc, cur) => {
      const [key, value] = Object.entries(cur).flat()
      acc[key] = { label: value, value }
      return acc
    }, {})
  }

  updatePrinterProfile = (key: string, value: string) => {
    const newValues = { ...this.userPrinters }
    newValues[key] = { label: value, value }
    this.userPrinters = newValues
  }
}

export default PrinterStore
